import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { View, TouchableWithoutFeedback, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { a as AppIcon, A as AppText } from './index-6b88191c.esm.js';

const AppPlaceholderView = _ref => {
  let {
    wrapperStyle,
    iconStyle,
    icon,
    fontColor,
    color,
    size = 40,
    mainCaption,
    mainCaptionStyle,
    subCaption,
    subCaptionStyle,
    isClickable,
    onPress = () => {},
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = styleGenerator(currentTheme);
  const coreComponent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: icon,
    color: color,
    size: size,
    style: [styles.iconStyle, iconStyle]
  }), /*#__PURE__*/React__default.createElement(AppText, {
    isHoverable: false,
    fontWeight: "bold",
    wrapperStyle: {
      paddingTop: 20
    },
    color: fontColor,
    style: [styles.mainCaptionStyle, mainCaptionStyle],
    isClickable: isClickable,
    onPress: onPress
  }, mainCaption), /*#__PURE__*/React__default.createElement(AppText, {
    isHoverable: false,
    color: fontColor,
    style: [styles.subCaptionStyle, subCaptionStyle],
    isClickable: isClickable,
    onPress: onPress
  }, subCaption));
  return /*#__PURE__*/React__default.createElement(View, _extends({
    style: [styles.wrapperStyle, wrapperStyle]
  }, props), isClickable ? /*#__PURE__*/React__default.createElement(TouchableWithoutFeedback, {
    style: {
      flex: 1
    },
    onPress: onPress
  }, coreComponent) : coreComponent);
};
const styleGenerator = (props, size, ratio) => {
  var _props$theme, _props$theme2;
  return StyleSheet.create({
    wrapperStyle: {
      height: "100%",
      overflow: "hidden",
      width: "100%",
      marginHorizontal: 25,
      alignItems: "center",
      zIndex: -1
    },
    iconStyle: {
      paddingTop: 20
    },
    mainCaptionStyle: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.base_font_size,
      textAlign: "center"
    },
    subCaptionStyle: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.small_font_size,
      textAlign: "center"
    }
  });
};
AppPlaceholderView.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppPlaceholderView",
  "props": {
    "size": {
      "defaultValue": {
        "value": "40",
        "computed": false
      },
      "required": false
    },
    "onPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppPlaceholderView as A };
